import { createApiAction } from 'helpers';

export const GET_FEED_PROPOSAL_DATA = 'GET_FEED_PROPOSAL_DATA';
export const GET_FEED_PROPOSAL_DATA_SUCCESS = 'GET_FEED_PROPOSAL_DATA_SUCCESS';
export const GET_FEED_PROPOSAL_DATA_FAILURE = 'GET_FEED_PROPOSAL_DATA_FAILURE';

export const CLEAR_FEED_PROPOSAL_DATA = 'CLEAR_FEED_PROPOSAL_DATA';

export const getFeedProposalData = createApiAction(GET_FEED_PROPOSAL_DATA);
